export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      required: true,
      default: 0,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-section-header/market-section-header.js